import React from "react";
import Main from "../../components/Main"
import Client from "../client/Client";
import Customer from "../Customer/Customer";
import About from "../../components/About";
import WhatWeDo from "../../components/WhatWeDo";
import HowWeHelp from "../../components/HowWeHelp";
import Industries from "../../components/Industries";
import IndiaReady from "../../components/IndiaReady";
import WhyAbscod from "../../components/WhyAbscod";
// import Blog from "../../components/Blog";
// import ClientFeedback from "../ClientFeedback/ClientFeedback";
import Footer from "../Footer/Footer";
const Home = () => {
  return (
    <>
      <Main />
      <About />
      <WhatWeDo />
      <HowWeHelp />
      <Industries />
      <IndiaReady />
      <WhyAbscod />
      <Client />
      <Customer />

      {/* <Blog /> */}
      {/* <ClientFeedback /> */}
      <Footer />
    </>
  );
};

export default Home;
